import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.css';

document.addEventListener("DOMContentLoaded", function () {
    const lightbox = GLightbox({
        selector: 'js-lightbox',
        touchNavigation: true,
        autoplayVideos: true,
        plyr: {
            css: 'https://cdn.plyr.io/3.5.6/plyr.css',
            js: 'https://cdn.plyr.io/3.5.6/plyr.polyfilled.js',
            ratio: '16:9', // or '4:3'
            config: {
                youtube: {
                    noCookie: true,
                    rel: 0
                }
            }
        }
    });
});
